import { useDispatch, useSelector } from 'react-redux';
import {
    getAllWorkSchdule,
} from '../../../../../../reduxToolkit/EmployeeContractors/EmployeeContractorsSlice';
import {
    GetAllWorkSchdule,
    GetWorkTimeAccess
} from '../../../../../../reduxToolkit/EmployeeContractors/EmployeeContractorsApi';
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { errorMsg } from '../../../../../../Apis/functions';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle: Full Stack Developer - IBL
 * @Email: clopez@ibl.mx
 *
 */
const WorkShiftsSelectApp = (
    {
        workShiftsList,
        setWorkShiftsList,
        autoHeight
    }
) => {

    const dispatch = useDispatch();
    const elementRef = useRef(null);
    const workShiftSchedule = useSelector(getAllWorkSchdule);
    const [workShift, setWorkShift] = useState(null);
    const [emptyFields, setEmptyFields] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [workShiftAccessTime, setWorkShiftAccessTime] = useState(false);

    useLayoutEffect(() => {
        if(!autoHeight) return;
        if (elementRef?.current) {
            const rect = elementRef.current.getBoundingClientRect();
            const distanceTop = rect.top + 90;
            elementRef.current.style.setProperty('--top-value', `${distanceTop}px`);
        }
    }, []);

    useEffect(() => {
        dispatch(GetAllWorkSchdule());
    }, []);

    let workShiftPagination = {
        order: true,
        page: 0,
        size: 5,
        sortBy: 'id',
    };

    const handleWorkShift = (e) => {
        if (e?.target?.value) {
            let id = e.target.value;
            let name = workShiftSchedule.find((item) => item?.id === e.target.value).name;
            setWorkShift({ id: id, name: name });
            const body = {
                id: id,
                contractPagination: workShiftPagination
            }
            dispatch(GetWorkTimeAccess(body)).then(({ payload: { data: { data, success, code } } }) => {
                if (success) setWorkShiftAccessTime(data);
                else errorMsg(code)
            })
        }
        setEmptyFields(false);
    }

    const handleAdded = () => {
        setWorkShiftsList([...workShiftsList, {...workShift,
            added: true,
            new: true
        }]);
        setWorkShift(null);
    }

    return {
        elementRef,
        workShiftAccessTime,
        workShiftSchedule,
        handleWorkShift,
        workShift, setWorkShift,
        emptyFields, setEmptyFields,
        showModal, setShowModal,
        handleAdded
    }

}

export default WorkShiftsSelectApp
